import PropTypes from 'prop-types'
import { useContext } from 'react'

import { faClone } from '@fortawesome/pro-light-svg-icons'

import swal from 'sweetalert2'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import handleCallbackAction from '@functions/handleCallbackAction'

import {
  Box, DashboardModuleListItem, Link,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useProviderPackageItem, { generateUrls } from '@hooks/useProviderPackageItem'
import { generateUrls as generateProviderPriceListUrls } from '@hooks/useProviderPriceList'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

const confirmDelete = (deleteProviderPackageItem, deleteFn) => {
  const deleteProviderPackageItemPayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Product Deleted',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, delete it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Delete Product?',
  }).then(({ value }) => {
    if (value){
      deleteProviderPackageItem(deleteProviderPackageItemPayload)
    }
  })
}

const confirmDuplicate = (duplicateFn) => {
  const duplicatePayload = {
    callbacks: {
      action: duplicateFn,
    },
    toastText: 'Product Duplicated',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, duplicate it.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Duplicate Product?',
  }).then(({ value }) => {
    if (value){
      handleCallbackAction(duplicatePayload)
    }
  })
}

const ProviderPackageProductListItem = (props) => {
  const {
    providerPackageItem,
    providerPackageItem: {
      id, options_string, price, quantity, title,
    },
  } = props

  const pageContext = useContext(PageContext)
  const { callbacks: { deleteProviderPackageItem } } = pageContext

  const {
    callbacks: { deleteProviderPackageItem: deleteFn, duplicateProviderPackageItem: duplicateFn },
    providerPriceList,
  } = useProviderPackageItem(providerPackageItem)

  const { editProviderPriceListUrl } = generateProviderPriceListUrls({ id: providerPriceList?.id })

  const { serviceProductUrl } = generateUrls(providerPackageItem)

  const providerPricelistText = (
    <Box>
      ${price} &nbsp;
      <Link
        greyLink
        href={`${editProviderPriceListUrl}?redirect=${generateRedirectUrl()}`}
      >
        {providerPriceList?.title}
      </Link>
    </Box>
  )

  return (
    <DashboardModuleListItem
      secondaryText={providerPricelistText}
      title={`${quantity} x ${title}${options_string}`}
    >
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
      </DashboardModuleListItem.TertiaryText>

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDuplicate(duplicateFn)}
          icon={faClone}
        />

        <DashboardModuleListItem.Icon
          marginRight="medium"
          onClick={() => confirmDelete(deleteProviderPackageItem, deleteFn)}
          type="delete"
        />

        <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
          <DashboardModuleListItem.Icon href={`${serviceProductUrl}?redirect=${generateRedirectUrl()}`} type="link" />
        </ScopedConditionalContent>
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

ProviderPackageProductListItem.propTypes = {
  providerPackageItem: PropTypes.shape({
    id: PropTypes.number.isRequired,
    options_string: PropTypes.array,
    price: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
}

export default ProviderPackageProductListItem
